import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectors } from 'src/store';
import Container from 'src/components/pages/Activities/Painting/Levels/Container';

const PaintingLevels = ({
  getLevelsByCollectionId,
  hasLoaded,
  groupOrderNumber,
  levels,
  student,
  currency,
  ...props
}) => {
  useEffect(() => {
    getLevelsByCollectionId();
  }, [getLevelsByCollectionId]);

  return (
    <Container
      groupOrderNumber={groupOrderNumber}
      hasLoaded={hasLoaded}
      items={levels}
      student={student}
      currency={currency}
      {...props}
    />
  );
};

PaintingLevels.propTypes = {
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  currency: PropTypes.shape({}),
  groupOrderNumber: PropTypes.number,
  levels: PropTypes.arrayOf(PropTypes.shape({})),
  student: PropTypes.shape({}).isRequired,
};

PaintingLevels.defaultProps = {
  currency: null,
  groupOrderNumber: 0,
  levels: [],
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.dailyMap.getHasLoadedLevels(state),
  currency: selectors.dailyMap.getDailyMapCollection(state)?.currency,
  groupOrderNumber: selectors.dailyMap.getDailyMapCollection(state)
    ?.groupOrderNumber,
  levels: selectors.dailyMap.getDailyMapCollection(state)?.levels,
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(PaintingLevels);
